module.exports = __webpack_public_path__ + "static/img/osde-4.1831ff5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/osde-4.jpg
// module id = 27oU
// module chunks = 1